import React, { useEffect, useState } from 'react'
import "../../assets/style/eegisterProvider.css"
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import components from '../../components';
import { Link,Outlet,useNavigate, useLocation, useParams } from 'react-router-dom';
import ApiCall from '../../utils/Api';

const CheckConsumerDetail = () => {
  const[data,setdata]=useState([])
  const[searchData,setsearchData]=useState("")
  const [updateCount,setupdateCount]=useState("")
   const {id}=useParams()
    const navigate = useNavigate();
    const location = useLocation();
    const getAllProviderDataByAdmin=async()=>{
      try {
        const data=await ApiCall.SECURE_API.post(`/admin/searchConsumerByWalletAddress?walletAddress=${searchData}`)
        
        if(Array.isArray(data.data.data)){
          setdata(data.data.data)
        }else{
         let list=[data.data.data]
         setdata(list)
        }
      } catch (error) {
        console.log("Error getting provider data:", error)
        setdata([])
      }
    }
    console.log('location', location)
    useEffect(()=>{
  
      getAllProviderDataByAdmin()
    },[searchData,updateCount])
  return (
    <>
     {location.pathname=="/admin-panel/CheckProviderDetail/RegisterNewDataProvider"||location.pathname==`/admin-panel/CheckProviderDetail/PermissionsDetail/${id}`? <Outlet />:<div style={{width:"100%",backgroundColor:"#F3F4F8"}}>
     <span className='Loginheading'>
   <div style={{display:"flex",justifyContent:"space-between"}}>
   <span style={{paddingLeft:20}}>Fund Subscribers</span> 

    </div>     
 

     </span>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-around",width:"100%"}}>
                            <div style={{width:"95%",padding:27}} className='LoginScreen'>
                                <div style={{display:"flex",flexDirection:"column",justifyContent:"space-evenly"}}>
                                    <div style={{display:"flex",justifyContent:"center",marginTop:10}}>
                                        <span style={{width:"100%", fontFamily: 'Manrope, sans-serif'}}>Consumer Address</span>
                                    </div>
                                        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:10}}>
                                        <TextField style={{width:"100%"}} onChange={(e)=>{
                                          setsearchData(e.target.value)
                                          
                                        }} id="outlined-basic" label="Search Consumer" variant="outlined" />
                                        <div >
                    
                                        </div>
                                        </div>
                                </div>
                            
                            
                              

                            </div>
                            <div style={{width:"98%",marginTop:40}}>
                                <components.Table.ConsumerDetailsByAdminTable data={data} setupdateCount={setupdateCount} updateCount={updateCount}/>    
                            </div>  
                            
            </div>
         
</div>}
</>
  )
}

export default CheckConsumerDetail